export default class ResultModel {
    constructor(speed, power, bikeSettings, userSettings, bikeName, firstName = "", lastName = "", email = "", timestamp = "", expanded = false) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.speed = speed;
        this.power = power;
        this.bikeName = bikeName;
        this.bikeSettings = bikeSettings;
        this.userSettings = userSettings;
        this.expanded = expanded;
        timestamp.concat(" ");
        timestamp.concat(" ");
        const t = timestamp.split(/[- :]/);
        // console.log(timestamp);
        // console.log(t);
        this.datetime = new Date(Date.UTC(Number(t[0]), Number(t[1]) - 1, Number(t[2]), Number(t[3]), Number(t[4]), Number(t[5])));
    }
    get date() {
        return `${this.datetime.getDate()}/${this.datetime.getMonth() + 1}/${this.datetime.getFullYear()}`;
    }
    checkTime(i) {
        return (i < 10) ? '0' + i : i;
    }
    get time() {
        return `${this.checkTime(this.datetime.getHours())}:${this.checkTime(this.datetime.getMinutes())}`;
    }
}
